"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsPim_de_de = void 0;
function componentsPim_de_de() {
    return {
        "components.cartdetails.pleaselogin": "Bitte melden Sie sich an, um den Warenkorb nutzen zu können",
        "components.cartdetails.ordernow": "jetzt bestellen",
        "components.cartdetails.total": "Gesamtpreis",
        "components.cartdetails.noitems": "Ihr Warenkorb ist leer"
    };
}
exports.componentsPim_de_de = componentsPim_de_de;
